import { ProductCompliance } from '~/Api/CzSuklCompliance';
import GeneralProduct from '~/Api/Product/Product';

import ProductDataSource from './ProductDataSource';
import ReferencePrice from './ReferencePrice';

export default class Product {
	product: GeneralProduct;

	datasource: ProductDataSource;

	referencePrices: ReferencePrice[];

	packageSizeForSingleUnit: number | null;

	singleUnitPackageSize: boolean;

	selected: boolean;

	productCompliance: ProductCompliance;

	constructor(
		product: GeneralProduct,
		datasource: ProductDataSource,
		referencePrices: ReferencePrice[],
		packageSizeForSingleUnit: number | null,
		singleUnitPackageSize: boolean,
		selected: boolean,
		productCompliance: ProductCompliance
	) {
		this.product = product;
		this.datasource = datasource;
		this.referencePrices = referencePrices;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.singleUnitPackageSize = singleUnitPackageSize;
		this.selected = selected;
		this.productCompliance = productCompliance;
	}
}
